<template>
    <div>
        <h1 v-if="netflixSubscriptions.length" class="font-weight-light text-center">Netflix</h1>
        <v-card class="my-2" v-for="netflix in netflixSubscriptions" :key="netflix.id">
            <v-card-title>
                <h5 class="font-weight-light"> {{ netflix.bundleName }} </h5>
                <v-spacer></v-spacer>
                <v-btn depressed color="primary" class="font-weight-light">{{ netflix.partnerAccountIdentifier }}</v-btn>
            </v-card-title>

            <v-card-text>
                <div>
                    <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                        <div>
                            <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Tarifa</strong></h3>
                            <div class="d-flex flex-column justify-center">
                                <h5 class="font-weight-light grey--text"><strong>ID:</strong> {{ netflix.tariffId }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Nombre:</strong> {{ netflix.tariffName }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Sub-Tipo:</strong> {{ netflix.subType }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Tipo:</strong> {{ netflix.type }}</h5>
                            </div>
                        </div>
                        <div>
                            <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Línea</strong></h3>
                            <div class="d-flex flex-column justify-center">
                                <h5 class="font-weight-light grey--text"><strong>Principal:</strong> {{ netflix.isMainLine }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Estado:</strong> {{ netflix.status }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Segmento:</strong> {{ netflix.segmentType }}</h5>
                            </div>
                        </div>
                    </div>

                    <v-divider class="my-2"></v-divider>

                    <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                        <div>
                            <h3 class="font-weight-light mt-4 mb-2"><strong>Información de Activación</strong></h3>
                            <div class="d-flex flex-column justify-center">
                                <h5 class="font-weight-light grey--text"><strong>Fecha de Activación:</strong> {{ netflix.metadataInfo.activationDate }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Fecha de Desactivación:</strong> {{ netflix.metadataInfo.deactivationDate }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Razón de Desactivación:</strong> {{ netflix.metadataInfo.deactivationReason }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Razón de Desactivación Enum:</strong> {{ netflix.metadataInfo.deactivationReasonEnum }}</h5>
                            </div>
                        </div>
                        <div>
                            <h3 class="font-weight-light mt-4 mb-2"><strong>Otras Fechas</strong></h3>
                            <div class="d-flex flex-column justify-center">
                                <h5 class="font-weight-light grey--text"><strong>Fecha de Instalación:</strong> {{ netflix.metadataInfo.installationDate }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Fecha de Pre-Activación:</strong> {{ netflix.metadataInfo.preActivationDate }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Fecha de Venta:</strong> {{ netflix.metadataInfo.sellDate }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Fecha de Desagrupación:</strong> {{ netflix.metadataInfo.unbundledDate }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>

export default {
    props: {
        netflixSubscriptions: {
            type: Array,
        },
        selectedContractId: {
            type: String,
        },
    },
};
</script>